import React, { Suspense, useEffect, useLayoutEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ApiAlertModal from "./Components/ApiAlertModal/ApiAlertModal";
import { DataProvider } from "./Components/DataContext";
import { handleUnauthenticatedAccess, readLoginState } from "./utils/authGuard";
import DriverManagement from "./Pages/DriverManagement/DriverManagement";
import SalaryAwardsDetail from "./Pages/SalaryDisbursement/SalaryAwardsDetail";
import ViewTransactions from "./Pages/SalaryDisbursement/ViewTransactions";
import MyRequests from "./Pages/MyRequests/MyRequests";
import ViewRequestDetails from "./Pages/MyRequests/ViewRequestDetails";
import AddNewDriver from "./Pages/DriverManagement/AddNew ";
import ViewDriverDetails from "./Pages/DriverManagement/ViewDriverDetails";
import EditDriverDetails from "./Pages/DriverManagement/EditDriverDetails";
import TripAssignmentManagement from "./Pages/TripAssignment anagement/TripAssignmentManagement";
import TripBreakManagement from "./Pages/TripBreak/TripBreakManagement";
import ViewTrip from "./Pages/TripAssignment anagement/ViewTrip";
import AddNewTrip from "./Pages/TripAssignment anagement/AddNewTrip";
import ViewTripDetail from "./Pages/TripAssignment anagement/ViewTripDetails";
import AddNewExpense from "./Pages/TripAssignment anagement/AddNewExpense";
import SalaryDisbursement from "./Pages/SalaryDisbursement/SalaryDisbursement";
import SalaryDisburse from "./Pages/SalaryDisbursement/SalaryDisburse";
import AddNewRequest from "./Pages/MyRequests/AddNew ";
import Notifications from "./Pages/Notifications/Notifications";
const Layout = React.lazy(() => import("./Components/Layout/Layout"));
const Spinnerr = React.lazy(() => import("./Components/Spinner/Spinner"));
const Login = React.lazy(() => import("./Pages/Login/Login"));
const Verifiy = React.lazy(() => import("./Pages/Login/VerifiyOpt"));
const UpdatePassword = React.lazy(() => import("./Pages/Login/UpdatePassword"));
const ForgotPassword = React.lazy(() => import("./Pages/Login/ForgotPassword"));
const AuthLayout = React.lazy(() => import("./Components/Layout/AuthLayout"));

const isSessionExpired = () => {
  const lastActivityTime = localStorage.getItem("lastActivityTime");
  if (lastActivityTime) {
    return Date.now() - parseInt(lastActivityTime, 10) > 7 * 24 * 60 * 60 * 1000; // 7 days
  }
  return true;
};

function UnknownRouteRedirect() {
  const loginSuccess = useSelector((state) => state.loginInfo?.userInformation);
  const { isLoggedIn } = readLoginState(loginSuccess);

  return <Navigate to={isLoggedIn ? "/driver-management" : "/"} replace />;
}

function App() {
  useEffect(() => {
    if (isSessionExpired()) {
      localStorage.clear();
    }
  }, []);
  /** Must stay in sync with Login (sessionToken + status) and Redux after sign-in. */
  const PrivateOutlet = () => {
    const loginSuccess = useSelector((state) => state.loginInfo?.userInformation);
    const sessionAlive = !isSessionExpired();
    const { isLoggedIn: hasCredentials } = readLoginState(loginSuccess);
    const isLoggedIn = sessionAlive && hasCredentials;

    useLayoutEffect(() => {
      if (!isLoggedIn) {
        handleUnauthenticatedAccess();
      }
    }, [isLoggedIn]);

    if (!isLoggedIn) {
      return <Navigate to="/" replace />;
    }

    return <Outlet />;
  };
  return (
    <DataProvider>
    <Router>
      <ApiAlertModal />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<AuthLayout />}>
            <Route index element={<Login />} />
            <Route path="update-password" element={<UpdatePassword />} />
            <Route path="resetPassword" element={<UpdatePassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="verify-password" element={<Verifiy />} />
          </Route>
          <Route element={<PrivateOutlet />}>
            <Route element={<Layout />}>
              <Route path="/driver-management" element={<DriverManagement />} />
              <Route path="/driver-management/add-new" element={<AddNewDriver />} />
              <Route path="/driver-management/view-detail" element={<ViewDriverDetails />} />
              <Route path="/driver-management/edit-driver-details" element={<EditDriverDetails />} />
              <Route path="/trip-assignment-management" element={<TripAssignmentManagement />} />
              <Route path="/trip-assignment-management/view-trip" element={<ViewTrip />} />
              <Route path="/trip-assignment-management/add-new-trip" element={<AddNewTrip />} />
              <Route path="/trip-assignment-management/view-trip-details" element={<ViewTripDetail />} />
              <Route path="/trip-assignment-management/view-trip-details/add-expense" element={<AddNewExpense />} />
              <Route path="/trip-break" element={<TripBreakManagement />} />
              <Route path="/salary-disbursement" element={<SalaryDisbursement />} />
              <Route path="/salary-disbursement/salary-and-awards-detail" element={<SalaryAwardsDetail />} />
              <Route path="/salary-disbursement/salary-and-awards-detail/view-transactions" element={<ViewTransactions />} />
              <Route path="/salary-disbursement/salary-and-awards-detail/salary-disburse" element={<SalaryDisburse />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/my-requests" element={<MyRequests />} />
              <Route path="/my-requests/view-request-retails" element={<ViewRequestDetails />} />
              <Route path="/my-requests/add-new-request" element={<AddNewRequest />} />
            </Route>
          </Route>
          <Route path="*" element={<UnknownRouteRedirect />} />
        </Routes>
      </Suspense>
    </Router>
    </DataProvider>
  );
}

export default App;
